module.exports = __webpack_public_path__ + "img/category_two.27e675ad.jpeg";